(function(){
  function getCardRoot(el){
    return el.closest('[data-product-card], .product-card, .card, .grid-item, li, article');
  }
  function getCardImages(card){
    if(!card) return {main:null, hover:null};
    const container = card.querySelector(
      '[data-product-image], .product-card__image, .product-item__media, .media, .card__media, .product-media, a, figure'
    ) || card;
    let imgs = container.querySelectorAll('picture img');
    if (imgs.length === 0) imgs = container.querySelectorAll('img');
    const main  = imgs[0] || null;
    const hover = imgs[1] || null;
    if (!hover) {
      const bg = container.querySelector('[data-hover], [style*="background-image"]');
      if (bg && !bg.querySelector('img')) return { main: main || bg, hover: bg };
    }
    return { main, hover };
  }
  function clearSrcset(img){
    if (!img || img.tagName !== 'IMG') return;
    img.removeAttribute('srcset'); img.removeAttribute('data-srcset');
    const pic = img.closest('picture');
    if (pic) pic.querySelectorAll('source').forEach(s => { s.removeAttribute('srcset'); s.removeAttribute('data-srcset'); });
  }
  function setImage(el, url){
    if (!el || !url) return;
    if (el.tagName === 'IMG') { el.dataset.prev = el.currentSrc || el.src; clearSrcset(el); el.src = url; }
    else { el.dataset.prev = el.style.backgroundImage; el.style.backgroundImage = "url('"+url+"')"; }
  }
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.metal-dots--card .ls-swatch');
    if(!btn) return;
    e.preventDefault();
    const card = getCardRoot(btn); if(!card) return;
    const primary = btn.getAttribute('data-image');
    const hover   = btn.getAttribute('data-hover') || primary;

    const { main, hover: hoverEl } = getCardImages(card);
    setImage(main, primary); 
    setImage(hoverEl, hover);

    card.querySelectorAll('.metal-dots--card .ls-swatch').forEach(el => {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    // 🔹 update material label text
    const label   = btn.getAttribute('data-label');
    const labelEl = card.querySelector('[data-material-label]');
    if (labelEl && label) {
      labelEl.textContent = label;
    }
  }, { passive: false });
})();
